module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Share"
  }, [_c('div', {
    staticClass: "Share-header"
  }, [_c('transition', {
    attrs: {
      "name": "Share-contentForm-"
    }
  }, [(_vm.content.title && !_vm.submitted) ? _c('h2', {
    staticClass: "t-headingSm",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "Share-content"
  }, [_c('transition-group', {
    attrs: {
      "name": "Share-contentForm-"
    }
  }, [(!_vm.submitted) ? _c('div', {
    key: "shareContentForm",
    staticClass: "Share-contentForm"
  }, [_c('div', {
    staticClass: "Share-feedback",
    on: {
      "click": _vm.clear
    }
  }, [_c('div', {
    staticClass: "Share-feedbackText",
    domProps: {
      "textContent": _vm._s(_vm.feedback)
    }
  }), _vm._v(" "), (_vm.value) ? _c('icon', {
    staticClass: "Share-feedbackIcon",
    attrs: {
      "name": "x"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "Share-errorMessage",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Share-keyboard"
  }, _vm._l((_vm.keyboards[_vm.mode]), function(row) {
    return _c('div', {
      staticClass: "Share-keyboardRow"
    }, _vm._l((row), function(key) {
      return _c('div', {
        staticClass: "Share-keyboardKey",
        class: _vm.keyClass(key),
        attrs: {
          "data-value": key
        },
        on: {
          "click": function($event) {
            _vm.selectKey(key)
          }
        }
      }, [_c('span', {
        domProps: {
          "textContent": _vm._s(_vm.formatValue(key))
        }
      }), _vm._v(" "), (key === 'shift' || key === 'backspace') ? _c('icon', {
        staticClass: "Share-keyboardKeyIcon",
        attrs: {
          "name": key === 'shift' ? 'arrow-up-fancy' : 'arrow-left-fancy'
        }
      }) : _vm._e()], 1)
    }))
  })), _vm._v(" "), _c('div', {
    staticClass: "Share-utilities"
  }, [_c('div', {
    staticClass: "Share-keyboardKey Share-keyboardKey--isWide  Share-submit Share-keyboardKey--isActive Share-keyboardKey--untoggleable",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (_vm.submitted) ? _c('div', {
    key: "shareContentMessage",
    staticClass: "Share-contentMessage"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.submittedMessage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Share-contentMessageButtons"
  }, _vm._l((_vm.submittedButtons), function(button, index) {
    return _c('button-component', {
      key: index,
      attrs: {
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          button.method($event)
        }
      }
    }, [_vm._v("\n            " + _vm._s(button.label) + "\n          ")])
  }))]) : _vm._e()])], 1), _vm._v(" "), (_vm.content.footer) ? _c('p', {
    staticClass: "Share-footer t-small",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footer)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a26f54b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/Share.vue
// module id = 382
// module chunks = 1